import { Glasses, Sun, Eye, CircleDot, ArrowRight } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/business";

const SERVICES = [
  {
    icon: Glasses,
    title: "Armações",
    text: "Variedade de estilos para combinar com o seu rosto e a sua personalidade.",
    message: WA_MESSAGES.general,
    testid: "service-card-frames",
  },
  {
    icon: CircleDot,
    title: "Lentes",
    text: "Lentes para diferentes necessidades, com orientação na escolha ideal para você.",
    message: WA_MESSAGES.general,
    testid: "service-card-lenses",
  },
  {
    icon: Sun,
    title: "Óculos de Sol",
    text: "Proteção e estilo para o seu dia a dia. Consulte os modelos disponíveis.",
    message: WA_MESSAGES.sunglasses,
    testid: "service-card-sunglasses",
  },
  {
    icon: Eye,
    title: "Exame de Vista",
    text: "Realizamos o agendamento com profissionais parceiros. Consulte a disponibilidade.",
    message: WA_MESSAGES.exam,
    testid: "service-card-exam",
  },
];

export const Services = () => (
  <section
    id="produtos"
    data-testid="services-section"
    className="scroll-mt-24 bg-stone-50"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div className="max-w-2xl" data-reveal>
        <p
          data-testid="services-overline"
          className="text-xs font-bold uppercase tracking-[0.2em] text-brand"
        >
          Produtos e Serviços
        </p>
        <h2
          data-testid="services-heading"
          className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-stone-900"
        >
          Tudo para a sua visão, em um só lugar
        </h2>
        <p
          data-testid="services-text"
          className="mt-5 text-base sm:text-lg leading-relaxed text-stone-600"
        >
          Chame no WhatsApp para conhecer as opções disponíveis na loja.
          Teremos prazer em ajudar você a escolher.
        </p>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map(({ icon: Icon, title, text, message, testid }, index) => (
          <div
            key={testid}
            data-testid={testid}
            data-reveal
            style={{ transitionDelay: `${index * 80}ms` }}
            className="flex flex-col rounded-2xl border border-stone-200 bg-white p-7 hover:shadow-md hover:-translate-y-1 transition-all duration-200"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-light text-brand">
              <Icon className="w-6 h-6" />
            </div>
            <h3 className="mt-5 font-heading text-xl font-semibold text-stone-900">
              {title}
            </h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-stone-600">
              {text}
            </p>
            <a
              href={waLink(message)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${testid}-cta`}
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand hover:text-brand-dark transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              Consultar pelo WhatsApp
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);
